<template>
  <Container class="pt-6 w-full">
    <PageHeading :title="$t('pages.reports.reports_view.reports')"/>
  </Container>

  <main class="flex-1 overflow-auto">

    <div v-for="(category, key) in reportsByCategory" class="max-w-7xl mx-auto mt-10 mb-10 px-4 sm:px-6 py-6">
      <div class="flex items-center justify-start space-x-4 border-b border-surface-200 pb-4">
        <div class="flex-shrink-0">
          <component :is="getIcon(key)" :size="48" :stroke-width="1" class="text-surface-500"/>
        </div>
        <div class="flex-1">
        <h5 class="text-xl text-surface-700 font-bold leading-8">{{ category.name }}</h5>
        <p class="text-surface-500">{{ category.description }}</p>
        </div>
      </div>
      <div class="grid sm:grid-cols-2 xl:grid-cols-3 gap-4 mt-6">
        <div v-for="(report, index) in category.reports" :key="index">
          <ReportCard :report="report"></ReportCard>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import Container from "@/Components/Container.vue";
import ReportCard from "@/Widgets/Cards/ReportCard.vue";
import {mapStores} from "pinia";
import {useReportsStore} from "@/stores/reports.js";
import {IconRouter, IconReport, IconTruck} from '@tabler/icons-vue';

export default {
  name: "ReportsView",
  components: {PageHeading, Container, ReportCard, IconRouter, IconReport, IconTruck},
  data() {
    return {
      reportParams: {
        include: [
          'reportType',
          'reportType.category',
        ],
      },
    }
  },
  methods: {
    async indexReports() {
      await this.reportsStore.indexReports(this.reportParams);
    },
    getIcon(key) {
      return {
        'ASSETS': IconTruck,
        'DEVICES': IconRouter,
      }[key] ?? IconReport;
    }
  },
  computed: {
    ...mapStores(useReportsStore),
    reportsByCategory()
    {
      return this.reportsStore.getReports?.reduce((total, report) => {
        const groupByKey = report.report_type?.category?.key ?? 'UNKNOWN';
        if (!total.hasOwnProperty(groupByKey)){
          total[groupByKey] = {}
          total[groupByKey].name = report.report_type?.category?.name ?? 'Unknown';
          total[groupByKey].description = report.report_type?.category?.description ?? 'Reports which have not been categorised';
          total[groupByKey].reports = [];
        }
        total[groupByKey].reports.push(report);
        return total;
      }, {});
    }
  },
  mounted() {
    this.indexReports();
  }
}
</script>

<style scoped>

</style>